export interface GroupableInvoiceLine {
  groupName?: string | null;
  groupSortOrder?: number | null;
}

export interface InvoiceLineGroup<T> {
  key: string;
  name: string;
  sortOrder: number;
  lines: T[];
}

/**
 * Group invoice lines by their immutable work-order work snapshot (#1347).
 * Old invoices have no group metadata and deliberately land in one localized
 * fallback group instead of disappearing.
 */
export function groupInvoiceLines<T extends GroupableInvoiceLine>(
  lines: readonly T[],
  fallbackName: string,
): InvoiceLineGroup<T>[] {
  const groups = new Map<string, InvoiceLineGroup<T>>();

  for (const line of lines) {
    const name = line.groupName?.trim() || fallbackName;
    const sortOrder = line.groupSortOrder ?? Number.MAX_SAFE_INTEGER;
    const key = `${sortOrder}:${name}`;
    const existing = groups.get(key);
    if (existing) {
      existing.lines.push(line);
    } else {
      groups.set(key, { key, name, sortOrder, lines: [line] });
    }
  }

  return [...groups.values()].sort((a, b) => a.sortOrder - b.sortOrder);
}
